import apiClient from 'apiClient/index';
import { configure, makeAutoObservable, runInAction } from 'mobx';

import { IBaseError, RequireAtLeastOne } from './types/Errors';
import { IErrorSettings, IPopup } from './types/Popups';

export interface ICustomError extends IBaseError, IPopup<IErrorSettings> {}

configure({
  enforceActions: 'observed',
  isolateGlobalState: true,
  reactionRequiresObservable: true,
});
class ErrorsStore {
  private baseErrors: IBaseError[] = [];
  errors: ICustomError[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  private async fetchErrorData() {
    const filters = {
      active: true,
      AND: this.baseErrors.map(({ code }) => ({
        setting: { PopupErrorSetting: { code } },
      })),
    };

    const popups = await apiClient.popups.getPopups<IErrorSettings>({ where: filters });

    runInAction(() => {
      this.errors = popups.data.data.popups.map((popup) => ({
        ...this.baseErrors.find(({ code }) => code === popup.setting.code) as IBaseError,
        ...popup,
      }));
    });
  }

  set(error: IBaseError) {
    const isErrorAlreadyAdded = this.baseErrors.some(({ code }) => code === error.code);
    if (isErrorAlreadyAdded) return;

    this.baseErrors.push(error);
    this.fetchErrorData();
  }

  remove(error: RequireAtLeastOne<{ id: ICustomError['id'], code: ICustomError['code'] }>) {
    const filterKey = error.id ? 'id' : 'code';
    const filterValue = error[filterKey];

    this.errors = this.errors.filter((item) => item[filterKey] !== filterValue);
    this.baseErrors = this.errors.map(({ code, message }) => ({ code, message }));
  }
}

export default ErrorsStore;
